import {Entity} from '@s-ui/domain'

/**
 * @implements Entity
 * Motor Tag
 */
export default class TagEntity extends Entity {
  static TAG_SPONSORED_ID = 'patrocinado'

  constructor({id, url, text, rel}) {
    super({
      id,
      url,
      text,
      rel
    })
    this._id = id
    this._url = url
    this._text = text
    this._rel = rel
  }

  _getRel = () => (this._id.toLowerCase() === TagEntity.TAG_SPONSORED_ID ? this._rel : null)

  toJSON = () => ({
    id: this._id,
    url: this._url,
    text: this._text,
    rel: this._getRel()
  })
}
